import CommonEntry from "./CommonEntry";

export default function DistributionEntry() {
  return <CommonEntry type="Distribution" />;
}